module["exports"] = [
  "Noord-Holland",
  "Zuid-Holland",
  "Utrecht",
  "Zeeland",
  "Overijssel",
  "Gelderland",
  "Drenthe",
  "Friesland",
  "Groningen",
  "Noord-Brabant",
  "Limburg",
  "Flevoland"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nl/address/state.js
// module id = 852
// module chunks = 0